export const patrolPoint = {
    name: '',
    notes: '',
    type: '',
    account: '',
    client: '',
    site: '',
    geolocation: {
        latitude: '',
        longitude: '',
    },
    address: {
        cep: '',
        address: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        ibge: '',
        gia: '',
        name: '',
        lat: '',
        lng: '',
    },
    patrolPointNumber: null,
    radius: null,
    status: 'ACTIVE',
}
